<template>
	<div>
		<FunctionTitle :title="mainTitle" />
		<CommonFlame :title="pageTitle">
			<template v-if="!$vuetify.breakpoint.xs" v-slot:app-bar-btn>
				<v-select
					class="mr-10"
					v-model="tag_id"
					@change="fetchFiles($route.query.page ? $route.query.page : 1)"
					:items="type_tags"
					item-text="name"
					item-value="id"
					outlined
					dense
					hide-details
					background-color="white"
				/>
				<input style="display: none" ref="input" type="file" @change="selectedFile($event)" />
				<v-btn color="white" icon class="ml-5 mr-10" @click="btnClick()">
					<v-icon>mdi-paperclip-plus</v-icon>
					ファイル追加
				</v-btn>

				<FileHistoryDialog :deleted_files="deleted_files" />
			</template>

			<template v-if="$vuetify.breakpoint.xs">
				<v-row no-gutters class="mb-2" justify="end">
					<v-select
						v-model="tag_id"
						@change="fetchFiles($route.query.page ? $route.query.page : 1)"
						:items="type_tags"
						item-text="name"
						item-value="name"
						outlined
						dense
						hide-details
						class="mb-3"
					/>
					<input style="display: none" ref="input" type="file" @change="selectedFile($event)" />
					<v-btn color="secondary" dark class="mb-3 ml-2" @click="btnClick()">
						<v-icon>mdi-paperclip-plus</v-icon>
						ファイル追加
					</v-btn>
					<FileHistoryDialog :deleted_files="deleted_files" btn />
				</v-row>
			</template>
			<MatterFilesTable
				:attached_files="attached_files"
				:pagination="pagination"
				:authority_flag="authority_flag"
				:id="id"
				@drop-files="dropFile($event)"
				@get-page="getPage($event)"
				@open-file-select="btnClick()"
			/>
		</CommonFlame>
	</div>
</template>

<script>
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import FunctionTitle from "../shared/FunctionTitle.vue"
import CommonFlame from "../shared/CommonFlame.vue"
import TemplateDeleteDialog from "../shared/TemplateDeleteDialog.vue"
import MatterFilesTable from "../shared/MatterFilesTable.vue"
import FileHistoryDialog from "./components/FileHistoryDialog.vue"

export default {
	components: {
		FunctionTitle,
		CommonFlame,
		TemplateDeleteDialog,
		MatterFilesTable,
		FileHistoryDialog,
	},
	data() {
		return {
			id: this.$route.params["id"],
			mainTitle: "案件",
			pageTitle: "添付ファイル一覧",
			type_tags: [],
			// headers: [
			// 	{ text: "ファイル名", value: "", width: "600px" },
			// 	{ text: "", value: "", width: "50px" },
			// ],
			attached_files: [],
			tag_id: "null",
			files: [],
			pagination: {
				count: null,
				current: 1,
				limit_value: null,
				next: null,
				pages: null,
				previous: null,
			},
			deleted_files: [],
			authority_flag: false,
			users: [],
			btn: "",
		}
	},

	mounted() {
		const page = this.$route.query.page ? this.$route.query.page : 1
		this.fetchFiles(page)
	},

	methods: {
		fetchFiles(page) {
			authenticate.authenticateUser()
			const headers = authenticate.setHeader()
			axios
				.get(`/erp/v1/matters/${this.id}/attached_files`, {
					params: { tag_id: this.tag_id, page: page },
					headers,
				})
				.then((res) => {
					this.type_tags = res.data.type_tags
					this.type_tags.unshift({ id: "null", name: "全てのファイル" })
					this.attached_files = res.data.attached_files
					this.pagination = res.data.pagination
					this.deleted_files = res.data.deleted_files
					this.authority_flag = res.data.authority_flag
					if (this.attached_files.length == 0) {
						const target = document.querySelector("td")
						target.style.height = "140px"
					}
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		getPage(page) {
			this.fetchFiles(page)
		},
		dropFile(files) {
			const headers = authenticate.setHeader()
			files.forEach((file) => {
				const formData = new FormData()
				formData.append("file", file)
				let config = {
					headers: {
						"content-type": "multipart/form-data",
					},
				}
				axios
					.post(`/erp/v1/matters/${this.id}/attached_files`, formData, {
						params: { tag_id: this.tag_id, config: config },
						headers,
					})
					.then((res) => {
						this.$store.dispatch("setFlash", {
							text: "ファイルを追加しました",
							type: "notice",
						})
						this.fetchFiles(this.$route.query.page ? this.$route.query.page : 1)
					})
					.catch((err) => {
						errorHandling.errorResponse(err)
					})
			})
		},
		btnClick() {
			this.$refs.input.click()
		},
		async selectedFile(event) {
			const headers = authenticate.setHeader()
			this.files = [...event.target.files]
			this.files.forEach((file) => {
				const formData = new FormData()
				formData.append("file", file)
				let config = {
					headers: {
						"content-type": "multipart/form-data",
					},
				}
				axios
					.post(`/erp/v1/matters/${this.id}/attached_files`, formData, {
						params: { tag_id: this.tag_id, config: config },
						headers,
					})
					.then((res) => {
						this.$store.commit("setFlash", {
							text: "ファイルを追加しました",
							type: "notice",
						})
						this.fetchFiles(this.pagination.current)
					})
					.catch((err) => {
						errorHandling.errorResponse(err)
					})
			})
		},
	},
}
</script>

<style lang="scss" scoped>
@import "../../stylesheet/variable.scss";
.enter {
	border: 5px solid $sub-color;
}
</style>
